export default function (props: any) {
    return (
        <svg
            width="39px"
            height="40px"
            viewBox="0 0 39 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-M端-Smart-Generator-(Dual-Fuel)" transform="translate(-81.000000, -3584.000000)">
                    <g id="Time-Saving" transform="translate(81.000000, 3584.000000)">
                        <rect id="矩形" fillOpacity="0" fill="#49E1F9" x="0" y="0" width="39" height="40"></rect>
                        <ellipse id="椭圆形" stroke="#49E1F9" strokeWidth="2.51587855" cx="19.5" cy="20.625" rx="18.2420607" ry="18.1170607"></ellipse>
                        <path
                            d="M19.7661454,9.09090909 C19.7661454,18.4151866 19.7661454,23.0773253 19.7661454,23.0773253 C19.7661454,23.0773253 17.000386,23.0773253 11.4688672,23.0773253"
                            id="路径-10"
                            stroke="#49E1F9"
                            strokeWidth="2.41911399"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
